export const PERMISSIONS_TYPE = {
    LISTINGS: 'listings',
    STATS: 'stats',
    LEADS: 'leads',
    INBOX: 'inbox',
    STAFF: 'staff',
    PROFILE: 'profile',
  };